import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Megaphone } from "lucide-react";
import api from "@/lib/api";
import { Reveal } from "@/components/Reveal";

export const PromoBanner = () => {
  const [promos, setPromos] = useState([]);

  useEffect(() => {
    api.get("/promos").then((r) => setPromos(r.data)).catch(() => {});
  }, []);

  if (promos.length === 0) return null;

  return (
    <section className="bg-paper pt-6" data-testid="promo-banner">
      <div className="mx-auto max-w-7xl space-y-4 px-4 sm:px-8 lg:px-16">
        {promos.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.08}>
            <div className="relative overflow-hidden rounded-3xl bg-royal px-6 py-8 text-white shadow-xl shadow-royal/20 sm:px-10" data-testid={`promo-card-${p.id}`}>
              <div className="pointer-events-none absolute -right-10 -top-16 h-48 w-48 rounded-full bg-gold/25 blur-2xl" aria-hidden />
              <div className="relative flex flex-wrap items-center gap-5">
                <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-gold text-ink">
                  <Megaphone className="h-6 w-6" />
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="font-display text-xl font-extrabold leading-snug sm:text-2xl" data-testid={`promo-title-${p.id}`}>
                    {p.title}
                  </h3>
                  {p.body && <p className="mt-1 max-w-2xl text-sm text-white/80">{p.body}</p>}
                </div>
                {p.cta_text && p.cta_url && (
                  <Link
                    to={p.cta_url}
                    data-testid={`promo-cta-${p.id}`}
                    className="group flex shrink-0 items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-bold text-royal transition-all duration-200 hover:scale-[1.03] hover:shadow-lg"
                  >
                    {p.cta_text}
                    <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
                  </Link>
                )}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
